<template>
    <v-btn
        v-if="bind"
        v-wait:click.start="waitId"
        :loading="$wait.waiting(waitId)"
        v-bind="$attrs"
        @click="click"
    >
        <slot/>
    </v-btn>
    <v-btn
        v-else
        v-bind="$attrs"
        @click="click"
    >
        <slot/>
    </v-btn>
</template>
<script>
export default {
    props: ["waitId"],
    methods: {
        click() {
            this.$emit("click");
        },
    },
    data() {
        return {
            bind: !!this.waitId,
        };
    },
};
</script>